var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "template" },
    [
      _c("CopyQuestionsModal", {
        ref: "copyModal",
        attrs: { source: _vm.template, "source-type": "template" }
      }),
      _vm._v(" "),
      _c("UpdateQuestionsModal", {
        ref: "updateModal",
        attrs: { source: _vm.template, "source-type": "template" },
        on: { updated: _vm.refreshQuestions }
      }),
      _vm._v(" "),
      _vm.loading ? _c("LoadingOverlay") : _vm._e(),
      _vm._v(" "),
      _c(
        "b-alert",
        {
          attrs: {
            variant: "danger",
            fade: "",
            show: _vm.errorMsg !== null,
            dismissible: ""
          },
          on: {
            dismissed: function($event) {
              _vm.errorMsg = null
            }
          }
        },
        [
          _c(
            "strong",
            [
              _c(
                "b-avatar",
                { attrs: { size: "sm" } },
                [
                  _c("b-icon", {
                    attrs: { icon: "exclamation-thick", size: "is-small" }
                  })
                ],
                1
              ),
              _vm._v("\n      Import Error:\n    ")
            ],
            1
          ),
          _vm._v(" " + _vm._s(_vm.errorMsg) + "\n  ")
        ]
      ),
      _vm._v(" "),
      _vm.template
        ? _c(
            "Section",
            { staticClass: "template" },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _vm._v("\n      " + _vm._s(_vm.template.name) + " \n      "),
                  !_vm.template.user
                    ? _c("b-badge", [_vm._v("\n        S\n      ")])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("template", { slot: "subtitle" }, [
                _vm._v("\n      " + _vm._s(_vm.template.description) + "\n    ")
              ]),
              _vm._v(" "),
              _c(
                "template",
                { slot: "action" },
                [
                  _vm.showEditImportButtons
                    ? _c(
                        "b-dropdown",
                        {
                          staticClass: "template-import-dropdown",
                          attrs: {
                            position: "is-bottom-left",
                            "close-on-click": "",
                            "mobile-modal": false
                          }
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "trigger" }, slot: "trigger" },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "icon-button",
                                  attrs: {
                                    variant: "light",
                                    size: "sm",
                                    squared: "",
                                    title: "Import Template"
                                  }
                                },
                                [
                                  _c("IconImport"),
                                  _vm._v(" "),
                                  _vm.isDesktop
                                    ? _c("span", [_vm._v("Import")])
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-dropdown-item",
                            { on: { click: _vm.triggerLassoUpload } },
                            [
                              _vm._v(
                                "\n          Lasso Template format\n        "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-dropdown-item",
                            {
                              attrs: { disabled: !_vm.importAvailable },
                              on: { click: _vm.openAiImport }
                            },
                            [
                              _vm._v(
                                "\n          Import with A.I.\n          "
                              ),
                              _vm.tokensLoaded
                                ? _c(
                                    "small",
                                    {
                                      staticClass: "d-block",
                                      class: _vm.importAvailable
                                        ? "text-muted"
                                        : "text-danger"
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _vm.importAvailable
                                              ? _vm.importTokens +
                                                  " token" +
                                                  (_vm.importTokens === 1
                                                    ? ""
                                                    : "s") +
                                                  " remaining"
                                              : "No tokens remaining — contact support"
                                          ) +
                                          "\n          "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("input", {
                    ref: "lassoFileInput",
                    staticClass: "d-none",
                    attrs: { type: "file", accept: ".xlsx,.xls" },
                    on: { change: _vm.onLassoFileSelected }
                  }),
                  _vm._v(" "),
                  _c("RfiImportModal", { ref: "rfiImportModal" }),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "icon-button",
                      attrs: {
                        variant: "light",
                        size: "sm",
                        squared: "",
                        title: "Export Template"
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.exportTemplate(_vm.template)
                        }
                      }
                    },
                    [
                      _c("IconExport"),
                      _vm._v(" "),
                      _vm.isDesktop ? _c("span", [_vm._v("Export")]) : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.showEditImportButtons
                    ? _c(
                        "b-button",
                        {
                          staticClass: "icon-button",
                          attrs: {
                            variant: "light",
                            size: "sm",
                            squared: "",
                            title: "Add Question"
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.addTemplateQuestion(_vm.template)
                            }
                          }
                        },
                        [
                          _c("IconAddTemplateQuestion"),
                          _vm._v(" "),
                          _vm.isDesktop
                            ? _c("span", [_vm._v("Add Question")])
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", { staticClass: "action-separator" }, [
                    _vm._v("|")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "icon-button",
                      attrs: {
                        variant: _vm.questionsSelectActive ? "danger" : "inbox",
                        size: "sm",
                        squared: "",
                        title: _vm.questionsSelectActive
                          ? "Clear Selection"
                          : "Select Questions"
                      },
                      on: { click: _vm.toggleSelectQuestions }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.questionsSelectActive
                              ? _vm.clearLabel
                              : "Select Questions"
                          ) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.questionsSelectActive
                    ? _c(
                        "b-button",
                        {
                          staticClass: "icon-button",
                          attrs: {
                            variant: "inbox",
                            size: "sm",
                            squared: "",
                            title: _vm.questionSearchActive
                              ? "Select All Filtered Questions"
                              : "Select All Questions"
                          },
                          on: { click: _vm.addAllQuestions }
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.questionSearchActive
                                  ? "Select All (Filtered)"
                                  : "Select All"
                              ) +
                              "\n      "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.questionsSelected.length > 0
                    ? _c(
                        "b-button",
                        {
                          staticClass: "icon-button",
                          attrs: {
                            variant: "success",
                            size: "sm",
                            squared: "",
                            title: "Copy Selected Questions"
                          },
                          on: { click: _vm.showCopyModal }
                        },
                        [
                          _vm._v(
                            "\n        Copy " +
                              _vm._s(_vm.questionsSelected.length) +
                              " Questions\n      "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.questionsSelected.length > 0
                    ? _c(
                        "b-button",
                        {
                          staticClass: "icon-button",
                          attrs: {
                            variant: "success",
                            size: "sm",
                            squared: "",
                            title: "Update Selected Questions"
                          },
                          on: { click: _vm.showUpdateModal }
                        },
                        [
                          _vm._v(
                            "\n        Update " +
                              _vm._s(_vm.questionsSelected.length) +
                              " Questions\n      "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "template",
                { slot: "main" },
                [_c("CategoriesQuestions", { ref: "categoriesQuestions" })],
                1
              )
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }